const OnSelect = function(user_ids) {
  this.collection.selected_rows = user_ids
  this.collection.setSelectedItems(user_ids)
}
export default OnSelect